import React from 'react';
import { Grid, Typography } from '@mui/material';
import { SparkImageLoader } from 'sharedComponents/UI';
import BoardToolBar from './BoardToolBar';
// import { BoardChats } from './BoardChats';
import { useConversationStaters } from 'hooks/Board';
import { useCurrentUser } from 'hooks/common';

type Props = {
  boardID: string;
};
const AGENT_ID = 'a6daeebb-c235-4c62-b304-89f850c7aeab';
function SparkBlankBoard({ boardID }: Props) {
  const [userInput, setUserInput] = React.useState('');
  const { applicationUser } = useCurrentUser();
  const handleInputChange = (input: string) => {
    setUserInput(input);
  };
  const { conversationStarters } = useConversationStaters(AGENT_ID);

  return (
    <Grid container height='100vh' width='100vw'>
      <Grid container item height='min-content'>
        <BoardToolBar
          onVIewToggle={() => {}}
          boardID={boardID}
          isBoardBlank={true}
          isCanvasView={false}
        />
      </Grid>
      <Grid
        container
        justifyContent='flex-start'
        alignItems='center'
        flexDirection='column'
        gap={4}
        mt={-12}
      >
        <Typography
          variant='h3'
          className='color-text'
          sx={{
            fontFamily: 'Mont-SemiBold',
          }}
        >
          What can I help with {applicationUser?.attributes.name}?
        </Typography>
        <Grid
          container
          item
          justifyContent='center'
          gap={2}
          position='relative'
        >
          {conversationStarters?.map((starter) => (
            <Grid
              container
              item
              bgcolor='#fff'
              borderRadius='12px'
              maxWidth='350px'
              padding={1.5}
              flexDirection='column'
              border={(theme) => `1px solid ${theme.palette.borderColor}`}
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  borderColor: (theme) => theme.palette.primary.main,
                },
              }}
              position='relative'
              onClick={() => {
                handleInputChange(starter.attributes.message);
              }}
            >
              <Typography maxWidth='75%' paddingBottom='12px'>
                {starter.attributes.message}
              </Typography>
              {starter.attributes.iconURL && (
                <SparkImageLoader
                  src={starter.attributes.iconURL}
                  alt='action-1'
                  width='32px'
                  height='32px'
                  style={{
                    bottom: '8px',
                    right: '10px',
                    position: 'absolute',
                  }}
                />
              )}
            </Grid>
          ))}
        </Grid>
        <Grid
          width='100%'
          maxWidth='800px'
          paddingX={3}
          bottom='10px'
          position='absolute'
          sx={{
            pointerEvents: 'none',
          }}
        >
          {/* <BoardChats
            handleInputChange={handleInputChange}
            userInput={userInput}
            boardID={boardID}
          /> */}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default SparkBlankBoard;
